"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "milestoneInspectionForm", {
    enumerable: true,
    get: function() {
        return milestoneInspectionForm;
    }
});
const _authorization = require("../../../authorization");
const _constants = require("../../../constants");
const _constants1 = require("./constants");
const milestoneInspectionForm = {
    name: _constants1.MILESTONE_INSPECTION_SUBMISSION_TYPE_NAME,
    successMessage: "Your Milestone Inspection has been saved",
    preamble: null,
    postamble: null,
    description: null,
    canCreate: _authorization.CREATOR_AND_UP,
    canCreateGroups: [],
    category: _constants.SUBMISSION_CATEGORY.INSPECTIONS,
    modules: [
        _constants.SUBMISSION_TYPE_MODULE.MILESTONE_INSPECTION
    ],
    attachments: [
        {
            type: _constants.OBJECT_TYPE.PROPERTY
        }
    ],
    formStructure: {
        schema: {
            type: "object",
            required: [
                "phase"
            ],
            properties: {
                phase: {
                    type: "string",
                    oneOf: [
                        {
                            const: "phaseOne",
                            title: "Phase 1"
                        },
                        {
                            const: "phaseTwo",
                            title: "Phase 2"
                        },
                        {
                            const: "repairs",
                            title: "Repairs"
                        },
                        {
                            const: "complete",
                            title: "Complete"
                        }
                    ],
                    title: "Inspection phase"
                },
                repairsGroup: {
                    type: "object",
                    title: "Repairs",
                    required: [],
                    properties: {
                        repairsDueDate: {
                            type: [
                                "string",
                                "null"
                            ],
                            title: "Repairs commenced due date",
                            format: "date"
                        }
                    },
                    description: ""
                },
                phaseOneGroup: {
                    type: "object",
                    title: "Phase 1",
                    required: [],
                    properties: {
                        phaseOneDueDate: {
                            type: [
                                "string",
                                "null"
                            ],
                            title: "Phase 1 due date",
                            format: "date"
                        }
                    },
                    description: ""
                },
                phaseTwoGroup: {
                    type: "object",
                    title: "Phase 2",
                    required: [],
                    properties: {
                        phaseTwoDueDate: {
                            type: [
                                "string",
                                "null"
                            ],
                            title: "Phase 2 due date",
                            format: "date"
                        }
                    },
                    description: ""
                }
            }
        },
        uiSchema: {
            phase: {
                oneOf: [
                    {
                        const: "phaseOne",
                        title: "Phase 1",
                        display: _constants.TAG_DISPLAY.DEFAULT
                    },
                    {
                        const: "phaseTwo",
                        title: "Phase 2",
                        display: _constants.TAG_DISPLAY.WARNING
                    },
                    {
                        const: "repairs",
                        title: "Repairs",
                        display: _constants.TAG_DISPLAY.CRITICAL
                    },
                    {
                        const: "complete",
                        title: "Complete",
                        display: _constants.TAG_DISPLAY.NEUTRAL
                    }
                ],
                "ui:label": false,
                "ui:widget": "select",
                "ui:useAsTag": true,
                "ui:placeholder": "",
                "ui:canUpdate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ],
                "ui:viewOnRetrieve": [
                    "admin",
                    "manager",
                    "member",
                    "creator",
                    "view_only",
                    "guest"
                ],
                "ui:viewOnCreate": [
                    "admin",
                    "manager",
                    "member",
                    "creator"
                ]
            },
            "ui:order": [
                "phase",
                "phaseOneGroup",
                "phaseTwoGroup",
                "repairsGroup"
            ],
            repairsGroup: {
                "ui:label": true,
                "ui:order": [
                    "repairsDueDate"
                ],
                "ui:heading": "h1",
                "ui:hideError": true,
                repairsDueDate: {
                    "ui:label": false,
                    "ui:widget": "date",
                    "ui:placeholder": "",
                    "ui:tooltipText": "Set 180 days from Phase 2 completed date when repairs are required",
                    "ui:defaultToToday": false,
                    "ui:canUpdate": [
                        "admin",
                        "manager",
                        "member",
                        "creator"
                    ],
                    "ui:viewOnRetrieve": [
                        "admin",
                        "manager",
                        "member",
                        "creator",
                        "view_only",
                        "guest"
                    ],
                    "ui:viewOnCreate": [
                        "admin",
                        "manager",
                        "member",
                        "creator"
                    ]
                },
                "ui:description": ""
            },
            "ui:hideError": true,
            phaseOneGroup: {
                "ui:label": true,
                "ui:order": [
                    "phaseOneDueDate"
                ],
                "ui:heading": "h1",
                "ui:hideError": true,
                "ui:description": "",
                phaseOneDueDate: {
                    "ui:label": false,
                    "ui:widget": "date",
                    "ui:placeholder": "",
                    "ui:tooltipText": "Due date determined by age and height of property building",
                    "ui:defaultToToday": false,
                    "ui:canUpdate": [
                        "admin",
                        "manager",
                        "member",
                        "creator"
                    ],
                    "ui:viewOnRetrieve": [
                        "admin",
                        "manager",
                        "member",
                        "creator",
                        "view_only",
                        "guest"
                    ],
                    "ui:viewOnCreate": [
                        "admin",
                        "manager",
                        "member",
                        "creator"
                    ]
                }
            },
            phaseTwoGroup: {
                "ui:label": true,
                "ui:order": [
                    "phaseTwoDueDate"
                ],
                "ui:heading": "h1",
                "ui:hideError": true,
                "ui:description": "",
                phaseTwoDueDate: {
                    "ui:label": false,
                    "ui:widget": "date",
                    "ui:placeholder": "",
                    "ui:tooltipText": "Set 180 days from Phase 1 completed date value, when phase 2 is required",
                    "ui:defaultToToday": false,
                    "ui:canUpdate": [
                        "admin",
                        "manager",
                        "member",
                        "creator"
                    ],
                    "ui:viewOnRetrieve": [
                        "admin",
                        "manager",
                        "member",
                        "creator",
                        "view_only",
                        "guest"
                    ],
                    "ui:viewOnCreate": [
                        "admin",
                        "manager",
                        "member",
                        "creator"
                    ]
                }
            }
        }
    }
};

//# sourceMappingURL=data:application/json;base64,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